import {
  Box,
  Container,
  Step,
  StepConnector,
  StepIconProps,
  StepLabel,
  Stepper,
  Typography,
  useTheme,
} from '@mui/material'
import { stepConnectorClasses } from '@mui/material/StepConnector'
import { Outlet, useLocation } from 'react-router'
import { Check } from '@mui/icons-material'

const ColorlibStepIcon = (props: StepIconProps) => {
  const { active, completed } = props;
  const theme = useTheme()

  const icons = {
    1: completed ?  <Check sx={{color:theme.palette.grey[50]}} /> : <Typography variant="h5" sx={{color: active ? theme.palette.grey[50] : theme.palette.primary.dark}}>1</Typography>,
    2: completed ?  <Check sx={{color:theme.palette.grey[50]}} /> : <Typography variant="h5" sx={{color: active ? theme.palette.grey[50] : theme.palette.primary.dark}}>2</Typography>,
    3: completed ?  <Check sx={{color:theme.palette.grey[50]}} /> : <Typography variant="h5" sx={{color: active ? theme.palette.grey[50] : theme.palette.primary.dark}}>3</Typography>
  }
  return (
    <Box
      component="div"
      sx={{
        background: completed ? theme.palette.success.main : active ? theme.palette.primary.main : theme.palette.background.default,
        color: theme.palette.blue[600],
        width: '44px',
        height:'44px',
        borderRadius: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}

    >
      {icons[String(props.icon)]}
    </Box>
  )
}

export const VerifySteps = () => {
  const theme = useTheme()
  const location = useLocation()
  const steps = ['Email Verfication', 'About your Water', 'Input Results']
  const selectedStep = () => {
    if(location.pathname.includes('test-strip/email')){ return 0}
    if(location.pathname.includes('test-strip/otp')){ return 0}
    if(location.pathname.includes('test-strip/data')){ return 1}
    if(location.pathname.includes('test-strip/update')){ return 2}
  }
  return (
    <Container
      maxWidth="lg"
      sx={{
       // height: 'calc(100vh - 65px)',
        alignContent: 'center',

        display: 'flex',
        flexDirection: 'column',
        width: '100%',
      }}
    >
      <Box sx={{display: 'flex', justifyContent: 'center', width:'100%', py:2}}>
      <Stepper
        alternativeLabel
        orientation="horizontal"
        sx={{width:'500px'}}
        activeStep={selectedStep()}
        connector={
          <StepConnector
            sx={{
              top:'42px',
              left: '-20%',
              right: '80%',

              [`& .${stepConnectorClasses.line}`]: {
                height: 2,
                border: 0,
                backgroundColor: theme.palette.grey[300],
                borderRadius: 2,
              },
            }}
          />
        }
      >
        {steps.map((label) => (
          <Step key={label} sx={{ }}>
            <StepLabel
              sx={{}}
              slots={{
                stepIcon: ColorlibStepIcon,
              }}
            >
              <Typography
                component="p"
                variant="body-small"
                sx={{ textAlign: 'center' }}
              >{label}</Typography>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
      </Box>


    </Container>
  )
}
